import React from 'react'
import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'

type MuiTimePickerProps = {
  value?: Date | null
  onChange?: (d: Date | null) => void
  format?: '12' | '24'
  className?: string
  disabled?: boolean
  minutesStep?: number
}

const MuiTimePicker: React.FC<MuiTimePickerProps> = ({
  value,
  onChange,
  format = '24',
  className,
  disabled,
  minutesStep = 1,
}) => {
  const dayjsValue: Dayjs | null = value ? dayjs(value) : null

  const handleChange = (newValue: Dayjs | null) => {
    onChange?.(newValue ? newValue.toDate() : null)
  }

  const inputFormat = format === '12' ? 'hh:mm a' : 'HH:mm'
  const ampm = format === '12'

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        value={dayjsValue}
        onChange={handleChange}
        format={inputFormat}
        ampm={ampm}
        disabled={disabled}
        minutesStep={minutesStep}
        slotProps={{ textField: { size: 'small', className, fullWidth: true } }}
      />
    </LocalizationProvider>
  )
}

export default MuiTimePicker